import { Activity, LockKeyhole } from 'lucide-react'
import { useDashboard } from '@/api/queries'
import { Badge } from '@/components/ui/badge'
import { formatBusinessDateTime } from '@/lib/time'

export function StatusStrip() {
  const dashboard = useDashboard()
  const data = dashboard.data?.data_readiness
  const ready = Boolean(data?.ready && data.latest_dataset_version)
  return <div className="flex min-w-0 flex-wrap items-center gap-2 border-b bg-card/60 px-4 py-2 text-xs text-muted-foreground">
    <Badge variant="muted"><LockKeyhole className="mr-1 h-3 w-3" />研究 / 纸面模拟</Badge>
    <span className="inline-flex min-w-0 flex-1 items-center gap-1"><Activity className={`h-3 w-3 shrink-0 ${ready ? 'text-primary' : 'text-warning'}`} /><span className="min-w-0 break-words">{dashboard.isPending ? '正在检查数据…' : ready ? `数据已就绪 · ${formatBusinessDateTime(data?.latest_source_ts, '时间待定')}` : '数据尚未达到研究门槛'}</span></span>
  </div>
}
